import { useCallback, useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Services } from "./components/Services";
import { Portfolio } from "./components/Portfolio";
import { Differentials } from "./components/Differentials";
import { Process } from "./components/Process";
import { Contact } from "./components/Contact";
import { Briefing } from "./components/briefing/Briefing";
import { WhatsAppFab } from "./components/WhatsAppFab";

function App() {
  const [brief, setBrief] = useState(false);
  const openBrief = useCallback(() => setBrief(true), []);
  const closeBrief = useCallback(() => setBrief(false), []);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf = 0;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);

  useEffect(() => {
    if (brief) window.__lenis?.stop(); else window.__lenis?.start();
    document.documentElement.style.overflow = brief ? "hidden" : "";
    return undefined;
  }, [brief]);

  return (
    <div className="App">
      <Nav onBrief={openBrief} />
      <main>
        <Hero onBrief={openBrief} />
        <Marquee />
        <Services onBrief={openBrief} />
        <Portfolio onBrief={openBrief} />
        <Differentials />
        <Process />
        <Contact onBrief={openBrief} />
      </main>
      <WhatsAppFab />
      <AnimatePresence>{brief && <Briefing onClose={closeBrief} />}</AnimatePresence>
    </div>
  );
}

export default App;
